import { PageHero } from "@/pages/About";

export default function News() {
    return (
        <div>
            <PageHero title="News & Stories" subtitle="Community updates · Programme progress" />
            <section className="gsf-section" data-testid="news-empty">
                <div className="gsf-container">
                    <div className="gsf-card p-10 max-w-2xl">
                        <div className="gsf-eyebrow">Coming soon</div>
                        <h2 className="mt-3 font-serif text-2xl text-[color:var(--gsf-green-700)] font-bold">
                            The Foundation newsroom is being prepared.
                        </h2>
                        <p className="mt-4 text-[color:var(--gsf-body)] leading-relaxed">
                            Community stories, programme updates, event announcements and impact reports will be
                            published here as they are consolidated. In the meantime, subscribe to our updates or write
                            to us at{" "}
                            <a className="underline text-[color:var(--gsf-green-700)]" href="mailto:impact@globalseedzim.org">impact@globalseedzim.org</a>.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}
